export enum SwipeDirection {
  Left = 'Left',
  Right = 'Right',
  Reset = 'Reset',
  Click = 'Click'
}

export interface Point {
  x: number;
  y: number;
}

export interface SwipeDirectionArgs {
  initial: Point;
  current: Point;
}

const THRESHOLD = 10;
const RESET_TRESHOLD = 25;

const isClick = (diff: number) => diff <= THRESHOLD;
const isReset = (diff: number) => diff <= RESET_TRESHOLD;
export const isScroll = ({ initial, current }: SwipeDirectionArgs) => {
  const yDiff = Math.abs(initial.y - current.y);
  return yDiff >= THRESHOLD;
};
export const isSwipe = ({ initial, current }: SwipeDirectionArgs) => {
  const xDiff = Math.abs(initial.x - current.x);
  return xDiff >= THRESHOLD;
};

export const getSwipeDirection = ({ initial, current }: SwipeDirectionArgs) => {
  const diff = Math.abs(current.x - initial.x);

  if (isClick(diff)) {
    return SwipeDirection.Click;
  }
  if (isReset(diff)) {
    return SwipeDirection.Reset;
  }

  if (current.x > initial.x) {
    return SwipeDirection.Right;
  }

  return SwipeDirection.Left;
};

export const getPosition = <T = HTMLElement>(
  e: React.MouseEvent<T> | React.TouchEvent<T>
): Point => {
  const event = e.nativeEvent;
  if (window.TouchEvent !== undefined && event instanceof TouchEvent) {
    const { clientX, clientY } = event.touches[0];
    return { x: clientX, y: clientY };
  } else if (event instanceof MouseEvent) {
    const { clientX, clientY } = event;
    return { x: clientX, y: clientY };
  }

  return { x: 0, y: 0 };
};

interface CalcMoveTranslateValueArgs {
  carouselWidth: number;
  currentTranslateValue: number;
  currentPosition: Point;
  previousPosition: Point;
}

export const calcMoveTranslateValue = ({
  carouselWidth,
  currentTranslateValue,
  currentPosition,
  previousPosition
}: CalcMoveTranslateValueArgs) => {
  const HUNDRED = 100;
  const pixelsPerPercent = carouselWidth / HUNDRED;
  const difference = (previousPosition.x - currentPosition.x) / pixelsPerPercent;

  return currentTranslateValue + difference;
};

export const getTranslate3d = (translateValue: number) =>
  `translate3d(-${translateValue}%, 0px, 0px)`;

export const getContainerStyles = (translateValue: number, shouldAnimate: boolean) => ({
  transform: getTranslate3d(translateValue),
  transition: shouldAnimate ? 'transform .5s' : undefined
});
